import BaseResource from '@/lib/data/resource/BaseResource'

const sluggify = (str) => {
  return str.toLowerCase().replace(/ /g, '-')
}

export default class SocialMediaMentionsResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.Data = {
      currentMentions: payload.currentMentions ?? {},
      ...payload.peers?.reduce((acc, peer, idx) => {
        acc[sluggify(peer.title)] = peer
        return acc
      }, {})
    }

    // this.Data = {
    //   currentMentions: payload.currentMentions ?? {},
    //   bank2Mentions  : payload.bank2Mentions ?? {},
    //   bank3Mentions  : payload.bank3Mentions ?? {},
    //   bank4Mentions  : payload.bank4Mentions ?? {}
    // }

    this.AssetGroups = Object.keys(this.Data).map(bank => ({
      Title: this.Data[bank].title,
      Value: bank
    }))

    this.FormattedDays = Object.keys(this.Data).reduce((acc, bank) => {
      acc[bank] = (this.Data[bank]?.items ?? []).map(item => {
        const d = new Date(item.date)
        const day = d.getDate().toString().padStart(2, '0')
        const month = d.toLocaleDateString('en-US', { month: 'short' })
        const year = d.getFullYear().toString().slice(-2)
        return `${day} ${month} ${year}`
      })
      return acc
    }, {})

    this.Loaded = true
    this.EnableThresholdMap = false
  }

  getFormattedDays (bank) {
    return this.FormattedDays[bank ?? 'currentMentions']
  }

  getThresholds (bank) {
    return this.Data[bank ?? 'currentMentions']?.thresholds || []
  }

  getMaxThreshold (bank) {
    const maxValue = this.Data[bank ?? 'currentMentions']?.items?.reduce((max, item) => Math.max(max, item.mentions), 0) || 0
    const maxThreshold = this.Data[bank ?? 'currentMentions']?.thresholds?.reduce((max, threshold) => Math.max(max, threshold.axisThreshold), 0) || 0

    return Math.max(maxValue, maxThreshold)
  }

  getThresholdMap (bank) {
    return this.Data[bank ?? 'currentMentions']?.thresholds?.reduce((acc, threshold) => {
      acc[threshold.axisThreshold] = threshold.actualThreshold
      return acc
    }, {})
  }

  getMinThreshold (bank) {
    const minValue = this.Data[bank ?? 'currentMentions']?.items?.reduce((min, item) => Math.min(min, item.mentions), Infinity) || 0
    const minThreshold = this.Data[bank ?? 'currentMentions']?.thresholds?.reduce((min, threshold) => Math.min(min, threshold.axisThreshold), Infinity) || 0

    return Math.min(minValue, minThreshold)
  }
}
